export const convertDecimalMoneyToCents = ({ decimalAmount }: { decimalAmount: string }): string => {
  return Math.round(parseFloat(decimalAmount) * 100).toString()
}
